import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from './store/auth.js';

const AppLayout   = () => import('./Layouts/AppLayout.vue');
const Login       = () => import('./Pages/Login.vue');
const Dashboard   = () => import('./Pages/Dashboard.vue');
const Customers   = () => import('./Pages/Customers.vue');
const CustomerDetail = () => import('./Pages/CustomerDetail.vue');
const Devices     = () => import('./Pages/Devices.vue');
const DeviceDetail = () => import('./Pages/DeviceDetail.vue');
const Tickets     = () => import('./Pages/Tickets.vue');
const Enrolments  = () => import('./Pages/Enrolments.vue');
const Account     = () => import('./Pages/Account.vue');
const Apps        = () => import('./Pages/Apps.vue');
const AppDetail   = () => import('./Pages/AppDetail.vue');
const Profiles    = () => import('./Pages/Profiles.vue');
const Users       = () => import('./Pages/Users.vue');
const NotFound    = () => import('./Pages/NotFound.vue');

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/login', name: 'login', component: Login, meta: { public: true, title: 'Anmelden' } },
        {
            path: '/',
            component: AppLayout,
            children: [
                { path: '', name: 'dashboard', component: Dashboard, meta: { title: 'Übersicht' } },

                { path: 'customers', name: 'customers', component: Customers, meta: { title: 'Kunden', perms: ['customers.view'] } },
                { path: 'customers/:id(\\d+)', name: 'customer-detail', component: CustomerDetail, meta: { title: 'Kunde', perms: ['customers.view'] } },

                // Die Reiter sind echte Routenteile, damit ein Link auf
                // einen bestimmten Reiter zeigen kann.
                { path: 'devices', name: 'devices', component: Devices, meta: { title: 'Geräte', perms: ['visiondesk.view'] } },
                {
                    path: 'devices/:id(\\d+)/:tab(checks|inventory|config|messages|commands|history)?',
                    name: 'device-detail',
                    component: DeviceDetail,
                    meta: { title: 'Gerät', perms: ['visiondesk.view'] },
                },

                { path: 'tickets', name: 'tickets', component: Tickets, meta: { title: 'Anfragen', perms: ['visiondesk.view'] } },
                { path: 'apps', name: 'apps', component: Apps, meta: { title: 'Programme', perms: ['visiondesk.view'] } },
                { path: 'apps/:key', name: 'app-detail', component: AppDetail,
                  meta: { title: 'Programm', perms: ['visiondesk.view'] } },
                { path: 'enrolments', name: 'enrolments', component: Enrolments, meta: { title: 'Einrichtung', perms: ['visiondesk.manage'] } },
                { path: 'profiles', name: 'profiles', component: Profiles, meta: { title: 'Profile', perms: ['visiondesk.manage'] } },
                // Ohne Rechteangabe: das eigene Konto steht jedem offen,
                // der angemeldet ist — auch einem Kundenzugang.
                { path: 'konto', name: 'account', component: Account, meta: { title: 'Mein Konto' } },
                { path: 'users', name: 'users', component: Users, meta: { title: 'Benutzer', perms: ['users.manage'] } },

                { path: ':path(.*)*', name: 'not-found', component: NotFound, meta: { title: 'Nicht gefunden' } },
            ],
        },
    ],
});

router.beforeEach(async (to) => {
    const auth = useAuthStore();

    // Beim ersten Aufruf steht noch nicht fest, ob eine Sitzung besteht.
    if (!auth.ready) {
        await auth.refresh();
    }

    if (to.meta.public) {
        // Angemeldet auf der Anmeldemaske: weiter zur Übersicht.
        return auth.isAuthenticated ? { name: 'dashboard' } : true;
    }

    if (!auth.isAuthenticated) {
        return { name: 'login', query: to.fullPath === '/' ? {} : { next: to.fullPath } };
    }

    // Fehlt das Recht, ist die Seite nicht "verboten", sondern für diese
    // Person nicht vorhanden — die Navigation zeigt sie ohnehin nicht an.
    if (to.meta.perms && !auth.canAny(to.meta.perms)) {
        return { name: 'not-found' };
    }

    return true;
});

router.afterEach((to) => {
    document.title = to.meta.title ? `${to.meta.title} · VisionDesk` : 'VisionDesk';
});

export default router;
